var React = require('react');

function Voicemail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.848 31.5A10.468 10.468 0 0021 24c0-5.798-4.702-10.5-10.5-10.5S0 18.202 0 24s4.702 10.5 10.5 10.5h27C43.298 34.5 48 29.798 48 24s-4.702-10.5-10.5-10.5S27 18.202 27 24c0 2.938 1.207 5.594 3.152 7.5H17.848zm-7.348-15a7.5 7.5 0 10.001 15.001A7.5 7.5 0 0010.5 16.5zm27 15a7.5 7.5 0 10-.001-15.001A7.5 7.5 0 0037.5 31.5z"}));
}

Voicemail.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Voicemail;

Voicemail.default = Voicemail;
